module.exports = __webpack_public_path__ + "static/img/rank_255.a70d3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_255.png
// module id = cLKB
// module chunks = 1